"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const elements_ui_utils_1 = require("@hydrogen/elements.ui.utils");
const themes_1 = require("../themes");
const ContentBoxFunctionBar = (props) => {
    const layout = props.layout || 'card';
    const theme = themes_1.themes.contentBoxFunctionBar.layouts[layout];
    const position = props.position || 'top';
    return (react_1.default.createElement("div", { className: (0, elements_ui_utils_1.classNames)(theme.shared, theme.positions[position], props.className || '') }, props.children));
};
exports.default = ContentBoxFunctionBar;
//# sourceMappingURL=ContentBoxFunctionBar.js.map